module.exports = __webpack_public_path__ + "img/Monte_Kope_55.4d6957b8.jpg";